import miniColors from './miniColors'
import miniBorders from './miniBorders'
import theme from 'SRC/core/theme/theme'

export default {
  ...theme,
  borders: miniBorders,
  colors: miniColors
}



// WEBPACK FOOTER //
// ./src/core/theme/mini/miniTheme.js